import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faLinkedinIn,
    faLinkedin,
    faFacebook,
    faTwitter,
    faGithub,
    faStackOverflow,
    faGooglePlusG,
} from '@fortawesome/free-brands-svg-icons';
import {
    faBan,
    faAsterisk,
    faGlobe,
    faTimes,
    faChevronLeft,
    faChevronRight,
    faBars,
    faCommentDots,
    faCheck,
    faCheckCircle as fasCheckCircle,
    faTimesCircle as fasTimesCircle,
    faCircleNotch,
    faChevronUp,
    faShareAlt,
    faPrint,
    faFilePdf,
    faTrashAlt,
    faLock,
    faEdit,
    faCog,
    faPlus,
    faArrowLeft,
    faArrowRight,
    faPen,
    faExclamationCircle,
    faCaretDown,
    faSearch,
    faSortDown,
    faSortUp,
} from '@fortawesome/free-solid-svg-icons';
import {
    faCheckCircle as farCheckCircle,
    faTimesCircle as farTimesCircle,
    faQuestionCircle as farQuestionCircle,
    faClone as farClone,
} from '@fortawesome/free-regular-svg-icons';

library.add(faBan);
library.add(faAsterisk);
library.add(faLinkedinIn);
library.add(faLinkedin);
library.add(faFacebook);
library.add(faTwitter);
library.add(faGithub);
library.add(faStackOverflow);
library.add(faGooglePlusG);
library.add(faGlobe);
library.add(faTimes);
library.add(faBars);
library.add(faCommentDots);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(fasCheckCircle);
library.add(farCheckCircle);
library.add(fasTimesCircle);
library.add(farTimesCircle);
library.add(faCircleNotch);
library.add(faChevronUp);
library.add(faPrint);
library.add(faFilePdf);
library.add(faShareAlt);
library.add(faTrashAlt);
library.add(faLock);
library.add(faEdit);
library.add(faCog);
library.add(faCheck);
library.add(farQuestionCircle);
library.add(faPlus);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faPen);
library.add(faExclamationCircle);
library.add(faCaretDown);
library.add(faSearch);
library.add(faSortDown);
library.add(faSortUp);
library.add(farClone);
